import date from '../../common/js/validators/date';
import dateLessThanOrEqual from '../../common/js/validators/date-less-than-or-equal';
import dateGreaterThanOrEqual from '../../common/js/validators/date-greater-than-or-equal';
import treasuryRst27Api from '../../api/treasury-rts27-api';
import moment from 'moment';
import { required } from 'vuelidate/lib/validators';
import { saveAs } from 'file-saver';
import { BACKEND_DATE_FORMAT } from '../../common/js/constants/constants';
import { mapState, mapActions } from 'vuex';
import { VueSelect, VueSelectOption } from '@ui-common/vue-select';
import VueErrorMessage from '@ui-common/vue-error-message';
import VueDatepicker from '@ui-common/vue-datepicker';
import VueFormNotification from '@ui-common/vue-form-notification';

export default {
	data() {
		return {
			model: {
				isinCode: null,
				kezdoDatum: null,
				vegDatum: null
			},
			isinCode: null,
			security: null,
			inProgress: false,
			kezdoDatum: null,
			vegDatum: null,
			noContent: false
		};
	},
	props: ['editedStartDate', 'editedEndDate'],
	watch: {
		kezdoDatum(val) {
			if (val) {
				this.model.kezdoDatum = val;
			} else {
				this.model.kezdoDatum = null;
			}
		},
		vegDatum(val) {
			if (val) {
				this.model.vegDatum = val;
			} else {
				this.model.vegDatum = null;
			}
		},
		isinCode(val) {
			if (val) {
				this.model.isinCode = this.isinCode;
				this.security = null;
			}
		},
		security(val) {
			if (val) {
				this.model.isinCode = this.security;
				this.isinCode = null;
			}
		}
	},
	validations() {
		return {
			isinCode: !this.security ? { required } : {},
			security: !this.isinCode ? { required } : {},
			kezdoDatum: {
				required,
				validDate: date(BACKEND_DATE_FORMAT),
				dateLessThanOrEqual: dateLessThanOrEqual(BACKEND_DATE_FORMAT, this.maximumDate),
				dateGreaterThanOrEqual: dateGreaterThanOrEqual(BACKEND_DATE_FORMAT, this.startDate)
			},
			vegDatum: {
				required,
				validDate: date(BACKEND_DATE_FORMAT),
				dateLessThanOrEqual: dateLessThanOrEqual(BACKEND_DATE_FORMAT, this.maximumDate),
				dateGreaterThanOrEqual: dateGreaterThanOrEqual(BACKEND_DATE_FORMAT, this.startDate)
			}
		};
	},
	components: {
		VueSelect,
		VueSelectOption,
		VueErrorMessage,
		VueDatepicker,
		VueFormNotification
	},
	computed: {
		isMobile() {
			return this.$resize && this.$mq.below(767);
		},
		maximumDate() {
			return moment().subtract(1, 'day').format(BACKEND_DATE_FORMAT);
		},
		...mapState('treasuryRst27', ['startDate', 'securities', 'technicalError'])
	},
	methods: {
		...mapActions('treasuryRst27', ['init', 'setTechnialError']),
		download() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.inProgress = true;
				treasuryRst27Api.download(this.model).then(
					(response) => {
						if (response.status == 204) {
							this.noContent = true;
							this.inProgress = false;
						} else {
							this.noContent = false;
							const filename = response.headers.filename;
							const blob = new Blob([response.data]);
							const filesaver = saveAs(blob, filename);
							// IE hack: doesn't have onwriteend callback pfhh
							if (navigator.msSaveOrOpenBlob) {
								this.inProgress = false;
							} else {
								filesaver.onwriteend = () => {
									this.inProgress = false;
								};
							}
						}
					},
					() => {
						this.setTechnialError();
						this.inProgress = false;
					}
				);
			}
		}
	},
	created() {
		if (this.editedStartDate) {
			this.kezdoDatum = moment(this.editedStartDate).format(BACKEND_DATE_FORMAT);
		} else {
			this.kezdoDatum = moment().subtract(3, 'months').format(BACKEND_DATE_FORMAT);
		}
		if (moment(this.editedEndDate).diff(moment(), 'days') <= -1) {
			this.vegDatum = moment(this.editedEndDate).format(BACKEND_DATE_FORMAT);
		} else {
			this.vegDatum = moment().subtract(1, 'd').format(BACKEND_DATE_FORMAT);
		}
		this.init();
	}
};
